import Checkbox from '@/components/_ui/Checkbox'
import T from '@/components/Helpers/Translate'
import { isProductOptionSubscription } from '@/lib/utils/shared/IsProductOptionSubscription'
import type { CartItemType } from '@/store/types/cart'
import useGlobalStore from '@/store/useGlobalStore'

type Props = {
  cartItem: CartItemType
}

export const CartSheetSubscribeAndSaveCheckbox = ({ cartItem }: Props) => {
  const { handleSwapCartItems } = useGlobalStore()

  if (!cartItem.purchaseOptions) {
    return null
  }

  if (!cartItem.purchaseOptions?.some((po) => po.key === 'subscription')) {
    return null
  }

  return (
    <Checkbox
      checked={isProductOptionSubscription({ po: cartItem.po })}
      onChange={() => {
        handleSwapCartItems(cartItem)
      }}
      id={`subscribe-and-save-${cartItem.index}`}
    >
      <div className="flex items-center space-x-2">
        <span>
          {isProductOptionSubscription({ po: cartItem.po }) ? (
            <T>subscribed</T>
          ) : (
            <T>subscribe_and_save</T>
          )}
        </span>
      </div>
    </Checkbox>
  )
}
